var KibiJersey3D=(function(){"use strict";
var GLB_URL=window.KJP_GLB_URL||"https://cdn.shopify.com/s/files/1/0565/6317/1537/t/45/assets/kjp-shirt.glb",
_loaded=!1,_queue=[],CDN="https://cdn.jsdelivr.net/npm/three@0.134.0/",LIBS=window.KJP_LIBS||{};

/* ─────────────────────────────────────────────────────────────────────────
   THREE + OrbitControls + GLTFLoader script loader (unchanged from v3)
   ───────────────────────────────────────────────────────────────────────── */
function _script(primary,fallback,next){var called=!1,fbAdded=!1,s,s2;function ok(winner,loser){return function(){if(!called){if(called=!0,loser&&loser.parentNode)try{loser.parentNode.removeChild(loser)}catch(e){}next()}}}function addFb(){fbAdded||!fallback||called||(fbAdded=!0,s2=document.createElement("script"),s2.src=fallback,s2.onload=ok(s2,s),document.head.appendChild(s2))}s=document.createElement("script"),s.src=primary,s.onerror=addFb,s.onload=function(){ok(s,s2)()},setTimeout(addFb,12e3),document.head.appendChild(s)}
function _load(cb){if(_loaded){cb();return}_queue.push(cb),!(_queue.length>1)&&_script(LIBS.three||CDN+"build/three.min.js",LIBS.three?CDN+"build/three.min.js":null,function(){_script(LIBS.orbit||CDN+"examples/js/controls/OrbitControls.js",LIBS.orbit?CDN+"examples/js/controls/OrbitControls.js":null,function(){_script(LIBS.gltf||CDN+"examples/js/loaders/GLTFLoader.js",LIBS.gltf?CDN+"examples/js/loaders/GLTFLoader.js":null,function(){_loaded=!0,_queue.forEach(function(f){f()}),_queue=[]})})})}

/* ─────────────────────────────────────────────────────────────────────────
   Canvas painting — DO NOT CHANGE (verbatim from v3)
   ───────────────────────────────────────────────────────────────────────── */
var TS=1024;
function _rgba(hex,a){hex=hex.replace("#",""),hex.length===3&&(hex=hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2]);var r=parseInt(hex.slice(0,2),16),g=parseInt(hex.slice(2,4),16),b=parseInt(hex.slice(4,6),16);return"rgba("+r+","+g+","+b+","+(a==null?1:a)+")"}
function _hue(hex){hex=hex.replace("#",""),hex.length===3&&(hex=hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2]);var r=parseInt(hex.slice(0,2),16)/255,g=parseInt(hex.slice(2,4),16)/255,b=parseInt(hex.slice(4,6),16)/255,mx=Math.max(r,g,b),mn=Math.min(r,g,b),d=mx-mn,h=0;return d===0?h=0:mx===r?h=(g-b)/d%6:mx===g?h=(b-r)/d+2:h=(r-g)/d+4,h=Math.round(h*60),h<0&&(h+=360),h}
var PREMIUM_BASE_HUE=262;
function U(u){return u*TS}
function V(v){return(1-v)*TS}
function mulberry32(a){return function(){a|=0,a=a+1831565813|0;var t=Math.imul(a^a>>>15,1|a);return t=t+Math.imul(t^t>>>7,61|t)^t,((t^t>>>14)>>>0)/4294967296}}
function makeFabricMap(){var cv=document.createElement("canvas");cv.width=cv.height=128;var x=cv.getContext("2d");x.fillStyle="#8080ff",x.fillRect(0,0,128,128),x.strokeStyle="rgba(130,130,255,0.55)",x.lineWidth=1.4;for(var i=0;i<128;i+=4)x.beginPath(),x.moveTo(i,0),x.lineTo(i,128),x.stroke(),x.beginPath(),x.moveTo(0,i),x.lineTo(128,i),x.stroke();x.strokeStyle="rgba(165,165,255,0.22)",x.lineWidth=.6;for(var d=-128;d<256;d+=8)x.beginPath(),x.moveTo(d,0),x.lineTo(d+128,128),x.stroke();for(var rr=mulberry32(5),k=0;k<6;k++){var bx=rr()*128,by=rr()*128,rad=24+rr()*30,g=x.createRadialGradient(bx,by,0,bx,by,rad);g.addColorStop(0,"rgba(150,150,255,0.18)"),g.addColorStop(.6,"rgba(110,110,255,0.10)"),g.addColorStop(1,"rgba(128,128,255,0)"),x.fillStyle=g,x.beginPath(),x.arc(bx,by,rad,0,Math.PI*2),x.fill()}var t=new THREE.CanvasTexture(cv);return t.wrapS=t.wrapT=THREE.RepeatWrapping,t.repeat.set(22,22),t}
var PATTERNS={solid:function(x,c){x.fillStyle=c.primary,x.fillRect(0,0,TS,TS),x.fillStyle=c.secondary,x.fillRect(U(0),0,U(.105),TS),x.fillRect(U(.398),0,U(.525)-U(.398),TS),x.fillStyle=_rgba(c.secondary,.85),x.fillRect(U(.105),0,U(.03),TS),x.fillRect(U(.385),0,U(.013),TS),x.fillRect(U(.6),0,U(.015),TS),x.fillRect(U(.905),0,U(.015),TS)},geometric:function(x,c){x.fillStyle=c.primary,x.fillRect(0,0,TS,TS);for(var r=mulberry32(7),i=-3;i<16;i++){x.fillStyle=i%2===0?c.secondary:c.accent,x.globalAlpha=.1+i%3*.06;var y=i*78+r()*20;x.beginPath(),x.moveTo(0,y),x.lineTo(TS,y-150),x.lineTo(TS,y-95),x.lineTo(0,y+55),x.closePath(),x.fill()}for(var j=0;j<18;j++){x.fillStyle=c.secondary,x.globalAlpha=.06+r()*.1;var bx=r()*TS,by=r()*TS,s=40+r()*120;x.save(),x.translate(bx,by),x.rotate(-.6),x.fillRect(-s/2,-4,s,8),x.restore()}x.globalAlpha=1},grunge:function(x,c){x.fillStyle=c.primary,x.fillRect(0,0,TS,TS);for(var r=mulberry32(23),i=0;i<70;i++){x.fillStyle=i%2?c.secondary:c.accent,x.globalAlpha=.03+r()*.1;var bx=r()*TS,by=r()*TS,w=60+r()*260,h=10+r()*40;x.save(),x.translate(bx,by),x.rotate((r()-.5)*1.4),x.beginPath(),x.ellipse(0,0,w/2,h/2,0,0,Math.PI*2),x.fill(),x.restore()}for(var k=0;k<400;k++){x.fillStyle=k%3===0?c.accent:c.secondary,x.globalAlpha=.05+r()*.15;var px=r()*TS,py=r()*TS,rad=1+r()*4;x.beginPath(),x.arc(px,py,rad,0,Math.PI*2),x.fill()}x.globalAlpha=1},halftone:function(x,c){x.fillStyle=c.primary,x.fillRect(0,0,TS,TS);for(var r=mulberry32(99),step=18,gy=0;gy<TS;gy+=step)for(var dens=1-gy/TS,gx=0;gx<TS;gx+=step)if(r()<dens*.95){var rad=1.5+dens*6;x.fillStyle=r()>.7?c.secondary:c.accent,x.globalAlpha=.25+dens*.55,x.beginPath(),x.arc(gx,gy,rad,0,Math.PI*2),x.fill()}x.globalAlpha=1},camo:function(x,c){x.fillStyle=c.primary,x.fillRect(0,0,TS,TS);for(var r=mulberry32(42),cols=[c.secondary,c.accent,c.primary],i=0;i<70;i++){x.fillStyle=cols[i%3],x.globalAlpha=.55;var bx=r()*TS,by=r()*TS,rad=40+r()*90;x.beginPath();for(var a=0;a<Math.PI*2;a+=.45){var rr=rad*(.65+r()*.55),px=bx+Math.cos(a)*rr,py=by+Math.sin(a)*rr;a===0?x.moveTo(px,py):x.lineTo(px,py)}x.closePath(),x.fill()}x.globalAlpha=1}};
function paint(cv,c,t,pattern,premiumImg,logoImg){if(cv){var x=cv.getContext("2d");x.clearRect(0,0,TS,TS);var isPremium=!!premiumImg;if(isPremium){try{var rot=_hue(c.primary)-PREMIUM_BASE_HUE,canFilter="filter"in x;canFilter&&rot!==0&&(x.filter="hue-rotate("+rot+"deg)"),x.drawImage(premiumImg,0,0,TS,TS),canFilter&&(x.filter="none")}catch(e){(PATTERNS[pattern]||PATTERNS.solid)(x,c)}var vg=x.createRadialGradient(TS/2,TS/2,TS*.3,TS/2,TS/2,TS*.75);vg.addColorStop(0,"transparent"),vg.addColorStop(1,"rgba(0,0,0,0.12)"),x.fillStyle=vg,x.fillRect(0,0,TS,TS)}else(PATTERNS[pattern]||PATTERNS.solid)(x,c);var txtFill=t.textColor?t.textColor:isPremium?"#ffffff":c.accent,txtStroke=isPremium?"rgba(0,0,0,0.55)":_rgba(c.secondary,.55);if(!isPremium){x.fillStyle=c.accent,x.fillRect(U(.1),V(.345),U(.42)-U(.1),V(.3)-V(.345)),x.fillRect(U(.6),V(.345),U(.92)-U(.6),V(.3)-V(.345));var cuffH=t.sleeve==="full"?40:14;x.fillStyle=_rgba(c.accent,.9),x.fillRect(U(0),V(.4),U(.1),cuffH),x.fillRect(U(.4),V(.4),U(.125),cuffH)}x.save(),t.collar==="polo"?(x.fillStyle=_rgba(c.accent,.95),x.fillRect(U(.245),V(.86),U(.02),V(.74)-V(.86)),x.fillRect(U(.275),V(.86),U(.02),V(.74)-V(.86)),x.fillRect(U(.21),V(.855),U(.1),10)):(x.fillStyle=_rgba(c.accent,.95),x.fillRect(U(.18),V(.855),U(.36)-U(.18),12),x.fillRect(U(.675),V(.855),U(.835)-U(.675),12)),x.restore();var grad=x.createLinearGradient(0,0,TS,0);grad.addColorStop(0,_rgba("#ffffff",.07)),grad.addColorStop(.5,"transparent"),grad.addColorStop(1,_rgba("#000000",.06)),x.fillStyle=grad,x.fillRect(0,0,TS,TS);var LOGO_POS={left:{u:.325,v:.725,box:88},right:{u:.195,v:.725,box:88},center:{u:.26,v:.64,box:150},back:{u:.755,v:.47,box:110}},lp=LOGO_POS[t.logoPos]||LOGO_POS.left;if(logoImg){x.save();var ar=logoImg.width/logoImg.height,bw=lp.box,bh=lp.box;ar>1?bh=lp.box/ar:bw=lp.box*ar;try{x.drawImage(logoImg,U(lp.u)-bw/2,V(lp.v)-bh/2,bw,bh)}catch(e){}x.restore()}else x.save(),x.globalAlpha=.3,x.strokeStyle=txtFill,x.lineWidth=3,x.setLineDash([7,5]),x.beginPath(),x.arc(U(lp.u),V(lp.v),lp.box*.45,0,Math.PI*2),x.stroke(),x.setLineDash([]),x.fillStyle=txtFill,x.font="700 20px Arial",x.textAlign="center",x.fillText("LOGO",U(lp.u),V(lp.v)+6),x.restore();var FONTS={block:'"Arial Black", Arial, sans-serif',condensed:'"Bebas Neue", "Arial Narrow", sans-serif',rounded:'"Plus Jakarta Sans", Arial, sans-serif',stencil:'"Arial Black", Impact, sans-serif',serif:'Georgia, "Times New Roman", serif'},numFont=FONTS[t.font]||FONTS.block,nameWeight=t.font==="condensed"?"400":"800",numWeight=t.font==="condensed"?"400":"900",nameFont=t.font==="condensed"?FONTS.condensed:numFont,nm=(t.name||"TEAM").toUpperCase();x.save(),x.font=nameWeight+" 56px "+nameFont,x.textAlign="center",x.textBaseline="middle",x.lineWidth=isPremium?4:2,x.strokeStyle=txtStroke,x.fillStyle=txtFill,(function(){var cx=U(.755),cy=V(.81),R=620,gap=7,maxW=U(.3),size=56,widths,total;do{x.font=nameWeight+" "+size+"px "+nameFont,widths=[],total=0;for(var i=0;i<nm.length;i++){var w=x.measureText(nm[i]).width+gap;widths.push(w),total+=w}if(total-=gap,total<=maxW||size<=26)break;size-=3}while(!0);if(nm.length<=2||total<40)x.strokeText(nm,cx,cy),x.fillText(nm,cx,cy);else for(var arc=total/R,a=-arc/2,j=0;j<nm.length;j++){var half=(widths[j]-(j===nm.length-1?gap:0))/2,mid=a+half/R;x.save(),x.translate(cx+Math.sin(mid)*R,cy+R-Math.cos(mid)*R),x.rotate(mid),x.strokeText(nm[j],0,0),x.fillText(nm[j],0,0),x.restore(),a+=widths[j]/R}})(),x.restore(),x.save(),x.font=numWeight+" 250px "+numFont,x.textAlign="center",x.textBaseline="middle",x.lineWidth=isPremium?12:8,x.strokeStyle=txtStroke,x.strokeText(t.number||"10",U(.755),V(.6)),x.fillStyle=txtFill,x.fillText(t.number||"10",U(.755),V(.6)),x.restore()}}
function paintShorts(cv,col,t,pattern,premiumImg,logoImg){if(cv){var x=cv.getContext("2d");if(x.clearRect(0,0,TS,TS),premiumImg)try{var rot=_hue(col.primary)-PREMIUM_BASE_HUE;"filter"in x&&rot!==0&&(x.filter="hue-rotate("+rot+"deg)"),x.drawImage(premiumImg,0,0,TS,TS),x.filter="none"}catch(e){(PATTERNS[pattern]||PATTERNS.solid)(x,col)}else pattern==="solid"?(x.fillStyle=col.primary,x.fillRect(0,0,TS,TS)):(PATTERNS[pattern]||PATTERNS.solid)(x,col);var ink=t.textColor?t.textColor:premiumImg?"#ffffff":col.accent;if(x.fillStyle=col.accent,x.fillRect(0,TS*.93,TS,TS*.07),x.fillStyle=_rgba("#000",.1),x.fillRect(0,TS*.93-6,TS,6),x.fillStyle=col.secondary,x.fillRect(TS*.035,0,TS*.05,TS*.93),x.fillRect(TS*.915,0,TS*.05,TS*.93),x.fillStyle=col.accent,x.fillRect(0,0,TS*.42,TS*.06),x.fillRect(TS*.58,0,TS*.42,TS*.06),logoImg){var box=86,ar=logoImg.width/logoImg.height,bw=box,bh=box;ar>1?bh=box/ar:bw=box*ar,x.save();try{x.drawImage(logoImg,TS*.72-bw/2,TS*.45-bh/2,bw,bh)}catch(e){}x.restore()}else x.save(),x.globalAlpha=.3,x.strokeStyle=ink,x.lineWidth=3,x.setLineDash([7,5]),x.beginPath(),x.arc(TS*.72,TS*.45,38,0,Math.PI*2),x.stroke(),x.setLineDash([]),x.fillStyle=ink,x.font="700 18px Arial",x.textAlign="center",x.fillText("LOGO",TS*.72,TS*.45+6),x.restore();t.number&&(x.save(),x.font='900 84px "Arial Black",Arial',x.textAlign="center",x.textBaseline="middle",x.lineWidth=4,x.strokeStyle=_rgba("#000",.35),x.strokeText(t.number,TS*.28,TS*.45),x.fillStyle=ink,x.fillText(t.number,TS*.28,TS*.45),x.restore())}}

/* ─────────────────────────────────────────────────────────────────────────
   Single shared GLB load + normalize (fit whole scene to 1.5-unit height).
   Module-level cache keyed by URL: both viewer instances await one parse,
   then each CLONES the normalized scene and assigns its own materials.
   ───────────────────────────────────────────────────────────────────────── */
var _glbCache={};
function _loadGLBOnce(url,onDone,onErr){
  var c=_glbCache[url];
  if(c){
    if(c.scene){onDone(c.scene);return}
    if(c.error){onErr&&onErr(c.error);return}
    c.cbs.push({d:onDone,e:onErr});return;
  }
  c=_glbCache[url]={scene:null,error:null,cbs:[{d:onDone,e:onErr}]};
  new THREE.GLTFLoader().load(url,function(gltf){
    var root=gltf.scene;
    root.updateMatrixWorld(!0);
    var box=new THREE.Box3().setFromObject(root),
        size=box.getSize(new THREE.Vector3()),
        ctr=box.getCenter(new THREE.Vector3()),
        s=1.5/(Math.max(size.x,size.y,size.z)||1);
    root.scale.set(s,s,s);
    root.position.set(-ctr.x*s,-ctr.y*s,-ctr.z*s);
    root.updateMatrixWorld(!0);
    c.scene=root;
    var cbs=c.cbs;c.cbs=[];
    for(var i=0;i<cbs.length;i++)cbs[i].d(root);
  },void 0,function(err){
    c.error=err||new Error("glb load failed");
    var cbs=c.cbs;c.cbs=[];
    for(var i=0;i<cbs.length;i++)cbs[i].e&&cbs[i].e(c.error);
  });
}

/* ─────────────────────────────────────────────────────────────────────────
   Phase 2: per-fabric weave specs + shared normal-map texture cache.
   URLs are injected by the theme via window.KJP_FABRIC_TEX = {fabricId: url}.
   ───────────────────────────────────────────────────────────────────────── */
var FAB_SPECS={
  "pp-120":    {repeat:26,ns:.35,rough:.62},
  "hc-130":    {repeat:18,ns:.55,rough:.60},
  "hcm-150":   {repeat:24,ns:.50,rough:.55},
  "dryfit-160":{repeat:24,ns:.45,rough:.48},
  "dotdry-170":{repeat:20,ns:.60,rough:.45}
};
var _fabTexCache={};
/* three r134 quirk: normalMap has no independent UV transform — it inherits
   the base map's (repeat 1). So we PRE-TILE the weave into a 1536px canvas at
   the desired density instead of using texture.repeat. */
function _loadFabricTex(url,repeat,onDone){
  var c=_fabTexCache[url];
  if(c){
    if(c.tex){onDone(c.tex);return}
    if(c.failed){onDone(null);return}
    c.cbs.push(onDone);return;
  }
  c=_fabTexCache[url]={tex:null,failed:!1,cbs:[onDone]};
  var img=new Image;
  img.crossOrigin="anonymous";
  img.onload=function(){
    var SIZE=1536,ts=Math.max(40,Math.round(SIZE/repeat)),
        cv=document.createElement("canvas");
    cv.width=cv.height=SIZE;
    var x=cv.getContext("2d");
    for(var ty=0;ty<SIZE;ty+=ts)for(var tx=0;tx<SIZE;tx+=ts)x.drawImage(img,tx,ty,ts,ts);
    var t=new THREE.CanvasTexture(cv);
    t.wrapS=t.wrapT=THREE.RepeatWrapping;
    c.tex=t;var cbs=c.cbs;c.cbs=[];for(var i=0;i<cbs.length;i++)cbs[i](t);
  };
  img.onerror=function(){
    c.failed=!0;var cbs=c.cbs;c.cbs=[];for(var i=0;i<cbs.length;i++)cbs[i](null);
  };
  img.src=url;
}
/* Procedural studio environment (equirect canvas → PMREM): soft grey studio
   with three softbox highlights so the fabric reads with realistic sheen. */
function _makeEnvCanvas(){
  var cv=document.createElement("canvas");cv.width=512,cv.height=256;
  var x=cv.getContext("2d"),g=x.createLinearGradient(0,0,0,256);
  g.addColorStop(0,"#dfe3ee"),g.addColorStop(.45,"#aab0c4"),g.addColorStop(.62,"#8a8fa5"),g.addColorStop(1,"#565b6e"),
  x.fillStyle=g,x.fillRect(0,0,512,256);
  function softbox(cx,cy,w,h,alpha){
    var rg=x.createRadialGradient(cx,cy,2,cx,cy,Math.max(w,h));
    rg.addColorStop(0,"rgba(255,255,255,"+alpha+")"),rg.addColorStop(.6,"rgba(255,255,255,"+alpha*.5+")"),rg.addColorStop(1,"rgba(255,255,255,0)"),
    x.fillStyle=rg;x.save();x.translate(cx,cy);x.scale(w/Math.max(w,h),h/Math.max(w,h));x.beginPath();x.arc(0,0,Math.max(w,h),0,Math.PI*2);x.fill();x.restore();
  }
  softbox(128,70,90,46,.95);softbox(400,80,70,40,.75);softbox(256,40,150,26,.5);
  return cv;
}

/* Contract mesh names */
var BODY_NAMES={body_half:1,body_full:1,shorts_body:1,pants_body:1},
JERSEY_BODY_NAMES={body_half:1,body_full:1},
ALL_PARTS=["body_half","body_full","sec_sleeves_full","acc_cuffs","acc_col_round","acc_col_polo","sec_col_polo_under","acc_col_mandarin","shorts_body","acc_shorts_waist","pants_body","acc_pants_waist"];
function _catOf(nm){
  if(nm.indexOf("acc_")===0)return"acc";
  if(nm.indexOf("sec_")===0)return"sec";
  if(BODY_NAMES[nm])return"body";
  return"unknown";
}

/* ─────────────────────────────────────────────────────────────────────────
   Viewer factory
   ───────────────────────────────────────────────────────────────────────── */
function create(containerId,mode){
  var container=document.getElementById(containerId);
  if(!container)return null;

  /* loading spinner (verbatim from v3) */
  (function(){var w=document.createElement("div");w.style.cssText="display:flex;align-items:center;justify-content:center;height:100%;flex-direction:column;gap:10px;color:#7C3AED;font-family:sans-serif;font-size:13px";var ring=document.createElement("div");if(ring.style.cssText="width:42px;height:42px;border:3px solid #EDE9FE;border-top-color:#7C3AED;border-radius:50%;animation:kjp3d-spin .8s linear infinite",!document.getElementById("kjp3d-spin-style")){var st=document.createElement("style");st.id="kjp3d-spin-style",st.textContent="@keyframes kjp3d-spin{to{transform:rotate(360deg)}}",document.head.appendChild(st)}var l=document.createElement("span");l.textContent="Loading 3D…",w.appendChild(ring),w.appendChild(l),container.appendChild(w)})();

  var S={
    colors:{primary:"#7C3AED",secondary:"#FFFFFF",accent:"#F59E0B"},
    _target:{primary:"#7C3AED",secondary:"#FFFFFF",accent:"#F59E0B"},
    text:{name:"TEAM",number:"10",font:"block",sleeve:"half",collar:"round",logoPos:"left"},
    pattern:"solid",premiumImg:null,product:"jersey",logoImg:null,fabricId:"pp-120"
  };
  var _premiumCache={};
  var scene,camera,renderer,controls,model,cv,tex,rimLight,rafId,rimAngle=0,camAnim=null,_lerp=!1;
  var isShowcase=mode==="showcase";
  var parts={},_accMats=[],_secMats=[],_bodyMats=[],_fallback=!1;
  var _fitR=3.0,_fitCtr={x:0,y:0,z:0};

  _load(function(){for(;container.firstChild;)container.removeChild(container.firstChild);_init()});

  /* ── init scene / renderer / lights ── */
  function _init(){
    var W=container.clientWidth||400,H=container.clientHeight||480;
    scene=new THREE.Scene,scene.background=null;
    camera=new THREE.PerspectiveCamera(32,W/H,.05,100),camera.position.set(0,0,3);
    renderer=new THREE.WebGLRenderer({antialias:!0,alpha:!0,preserveDrawingBuffer:!0}),
    renderer.setSize(W,H),renderer.setPixelRatio(Math.min(window.devicePixelRatio,2)),
    THREE.sRGBEncoding!==void 0&&(renderer.outputEncoding=THREE.sRGBEncoding),
    renderer.toneMapping=THREE.ACESFilmicToneMapping,renderer.toneMappingExposure=1.05,
    renderer.domElement.setAttribute("role","img"),
    renderer.domElement.setAttribute("aria-label","Interactive 3D jersey preview. Drag to rotate, scroll to zoom."),
    container.appendChild(renderer.domElement);
    controls=new THREE.OrbitControls(camera,renderer.domElement),
    controls.enableDamping=!0,controls.dampingFactor=.08,controls.enableZoom=!0,
    controls.minDistance=1.6,controls.maxDistance=6,controls.autoRotate=isShowcase,
    controls.autoRotateSpeed=1.4,controls.enablePan=!1,controls.target.set(0,0,0),
    controls.maxPolarAngle=Math.PI*.78,controls.minPolarAngle=Math.PI*.22;
    /* image-based studio lighting + rebalanced direct lights (Phase 2) */
    try{
      if(THREE.PMREMGenerator){
        var envTex=new THREE.CanvasTexture(_makeEnvCanvas());
        envTex.mapping=THREE.EquirectangularReflectionMapping;
        var pm=new THREE.PMREMGenerator(renderer);pm.compileEquirectangularShader();
        scene.environment=pm.fromEquirectangular(envTex).texture;
        envTex.dispose();pm.dispose();
      }
    }catch(e){}
    scene.add(new THREE.AmbientLight(16777215,scene.environment?.3:.55));
    var key=new THREE.DirectionalLight(16777215,scene.environment?.75:1);key.position.set(2,3,4),scene.add(key);
    var fill=new THREE.DirectionalLight(15659263,.25);fill.position.set(-3,1,2),scene.add(fill);
    rimLight=new THREE.DirectionalLight(16773856,.4),rimLight.position.set(0,2,-4),scene.add(rimLight);
    scene.add(new THREE.HemisphereLight(15394559,16774888,scene.environment?.12:.22));
    var sheen=new THREE.PointLight(16777215,.3,12);sheen.position.set(0,1.2,4.5),scene.add(sheen);

    cv=document.createElement("canvas"),cv.width=cv.height=TS,
    tex=new THREE.CanvasTexture(cv),tex.flipY=!1,
    THREE.sRGBEncoding!==void 0&&(tex.encoding=THREE.sRGBEncoding),
    tex.anisotropy=renderer.capabilities.getMaxAnisotropy(),
    paint(cv,S.colors,S.text,S.pattern,S.premiumImg,S.logoImg),tex.needsUpdate=!0;

    _loadGLBOnce(GLB_URL,function(sharedRoot){
      model=sharedRoot.clone(!0);
      _assignMaterials(model);
      scene.add(model);
      _applyFabric(); /* per-fabric weave normal map + roughness */
      _applyVisibility(); /* frames the model via _refit; showcase autorotate preserved */
      _ground();
    },function(){/* load failed: leave lights/canvas, no crash */});

    window.addEventListener("resize",_resize);
    if(window.ResizeObserver){var ro=new ResizeObserver(function(){_resize()});ro.observe(container)}
    _animate();
  }

  function _ground(){var g=new THREE.Mesh(new THREE.PlaneGeometry(3,3),new THREE.ShadowMaterial({opacity:0}));g.rotation.x=-Math.PI/2,g.position.y=-.85,scene.add(g)}

  /* ── per-instance material assignment on the cloned scene ── */
  function _assignMaterials(rootClone){
    var foundBody=!1,firstMesh=null,unknown=[];
    rootClone.traverse(function(o){
      if(!o.isMesh)return;
      if(!firstMesh)firstMesh=o;
      var nm=o.name||"";
      /* quantized GLBs (gltfpack) carry the name on a wrapper node above the
         actual mesh node — resolve upward until a contract name is found */
      if(_catOf(nm)==="unknown"){
        for(var p=o.parent;p&&p!==rootClone;p=p.parent){
          if(_catOf(p.name||"")!=="unknown"){nm=p.name;break}
        }
      }
      var cat=_catOf(nm);
      if(cat==="body"){
        foundBody=!0;
        var isJersey=!!JERSEY_BODY_NAMES[nm],
            m=new THREE.MeshStandardMaterial({map:tex,roughness:.6,metalness:.06});
        if(isJersey){m.normalMap=makeFabricMap(),m.normalScale=new THREE.Vector2(.08,.08)}
        o.material=m,_bodyMats.push(m),parts[nm]=o;
      }else if(cat==="acc"){
        var ma=new THREE.MeshStandardMaterial({color:new THREE.Color(S.colors.accent),roughness:.55,metalness:.05});
        o.material=ma,_accMats.push(ma),parts[nm]=o;
      }else if(cat==="sec"){
        var ms=new THREE.MeshStandardMaterial({color:new THREE.Color(S.pattern==="solid"?S.colors.secondary:S.colors.primary),roughness:.6,metalness:.05});
        o.material=ms,_secMats.push(ms),parts[nm]=o;
      }else{
        /* unknown mesh — tentatively a jersey body (fallback path) */
        var mu=new THREE.MeshStandardMaterial({map:tex,roughness:.6,metalness:.06,normalMap:makeFabricMap(),normalScale:new THREE.Vector2(.08,.08)});
        o.material=mu,_bodyMats.push(mu),unknown.push(o);
      }
    });
    if(!foundBody){
      /* old single-mesh GLB (e.g. T_Shirt_male): treat it as body_half */
      _fallback=!0;
      if(firstMesh)parts.body_half=firstMesh;
    }else{
      /* contract GLB: hide any stray unnamed meshes */
      for(var i=0;i<unknown.length;i++)unknown[i].visible=!1;
    }
  }

  /* ── visibility matrix (jersey / shorts / pants) ── */
  function _setVis(name,v){if(parts[name])parts[name].visible=!!v}
  function _hideAll(){for(var k in parts){if(parts.hasOwnProperty(k)&&parts[k])parts[k].visible=!1}}
  function _applyVisibility(){
    if(_fallback){
      if(parts.body_half)parts.body_half.visible=!0;
      _repaint();_refit();return;
    }
    /* default-hide every registered part, then reveal only the active set */
    _hideAll();
    var p=S.product,full=S.text.sleeve==="full",cl=S.text.collar;
    if(p==="jersey"){
      _setVis(full?"body_full":"body_half",!0);
      if(full){_setVis("sec_sleeves_full",!0);_setVis("acc_cuffs",!0)}
      if(cl==="polo"){_setVis("acc_col_polo",!0);_setVis("sec_col_polo_under",!0)}
      else if(cl==="mandarin"){_setVis("acc_col_mandarin",!0)}
      else{_setVis("acc_col_round",!0)} /* round is the default collar */
    }else if(p==="shorts"){
      _setVis("shorts_body",!0);_setVis("acc_shorts_waist",!0);
    }else if(p==="pants"){
      _setVis("pants_body",!0);_setVis("acc_pants_waist",!0);
    }
    _repaint();_refit();
  }

  /* ── per-fabric weave: normal map + roughness on all body materials ── */
  var _procFab=null;
  function _applyFabric(){
    var spec=FAB_SPECS[S.fabricId]||FAB_SPECS["pp-120"],
        url=(window.KJP_FABRIC_TEX||{})[S.fabricId];
    function set(t){
      var ns=spec.ns;
      /* procedural fallback has no pre-tiling — keep it subtle like v3 */
      if(!t){_procFab||(_procFab=makeFabricMap()),t=_procFab,ns=.08}
      for(var i=0;i<_bodyMats.length;i++){
        var m=_bodyMats[i];
        m.normalMap=t,m.normalScale=new THREE.Vector2(ns,ns),
        m.roughness=spec.rough,m.needsUpdate=!0;
      }
    }
    url?_loadFabricTex(url,spec.repeat,set):set(null);
  }
  function _tint(){
    var i,secCol=S.pattern==="solid"?S.colors.secondary:S.colors.primary;
    for(i=0;i<_accMats.length;i++)_accMats[i].color.set(S.colors.accent);
    for(i=0;i<_secMats.length;i++)_secMats[i].color.set(secCol);
  }
  function _repaint(){
    S.product==="jersey"?paint(cv,S.colors,S.text,S.pattern,S.premiumImg,S.logoImg):paintShorts(cv,S.colors,S.text,S.pattern,S.premiumImg,S.logoImg);
    tex&&(tex.needsUpdate=!0);
    _tint();
  }

  function _glow(){var h=S.colors.primary.replace("#",""),r=parseInt(h.slice(0,2),16),g=parseInt(h.slice(2,4),16),b=parseInt(h.slice(4,6),16);document.documentElement.style.setProperty("--kjp-jersey-glow","rgba("+r+","+g+","+b+",0.36)"),document.querySelectorAll("[data-kjp-glow-bg]").forEach(function(el){el.style.background="radial-gradient(ellipse 80% 80% at 50% 42%,rgba("+r+","+g+","+b+",0.34) 0%,transparent 70%)"})}

  function _lerpColors(){if(!_lerp)return;var done=!0;function lh(a,b,t){a=a.replace("#",""),b=b.replace("#","");var r=Math.round(parseInt(a.slice(0,2),16)*(1-t)+parseInt(b.slice(0,2),16)*t),g=Math.round(parseInt(a.slice(2,4),16)*(1-t)+parseInt(b.slice(2,4),16)*t),bl=Math.round(parseInt(a.slice(4,6),16)*(1-t)+parseInt(b.slice(4,6),16)*t);return"#"+("0"+r.toString(16)).slice(-2)+("0"+g.toString(16)).slice(-2)+("0"+bl.toString(16)).slice(-2)}["primary","secondary","accent"].forEach(function(k){if(S.colors[k]!==S._target[k]){var nx=lh(S.colors[k],S._target[k],.18);S.colors[k]=nx,nx!==S._target[k]&&(done=!1)}}),_repaint(),_glow(),done&&(_lerp=!1)}

  /* ── camera fit from the visible bounding box ── */
  function _effVisible(o){var n=o;while(n&&n!==model){if(n.visible===!1)return!1;n=n.parent}return o.visible!==!1}
  function _refit(){
    if(!camera||!model||!controls)return;
    model.updateMatrixWorld(!0);
    var box=new THREE.Box3(),any=!1;
    model.traverse(function(o){
      if(o.isMesh&&_effVisible(o)){box.union(new THREE.Box3().setFromObject(o)),any=!0}
    });
    if(!any)return;
    var size=box.getSize(new THREE.Vector3()),ctr=box.getCenter(new THREE.Vector3()),
        W=container.clientWidth||400,H=container.clientHeight||480,aspect=W/H,
        vFov=camera.fov*Math.PI/180,hFov=2*Math.atan(Math.tan(vFov/2)*aspect),
        distV=(size.y/2)/Math.tan(vFov/2),distH=(size.x/2)/Math.tan(hFov/2),
        R=Math.max(distV,distH)*1.22+size.z*.6;
    _fitR=R;_fitCtr={x:ctr.x,y:ctr.y,z:ctr.z};
    controls.minDistance=.55*R;controls.maxDistance=2.4*R;
    controls.target.set(ctr.x,ctr.y,ctr.z);
    var dir=camera.position.clone().sub(ctr);
    if(dir.lengthSq()<1e-6)dir.set(0,0,1);
    dir.normalize();
    camAnim={from:{x:camera.position.x,y:camera.position.y,z:camera.position.z},
             to:{x:ctr.x+dir.x*R,y:ctr.y+dir.y*R,z:ctr.z+dir.z*R},t:0,t0:Date.now()};
  }

  function _setView(v){
    if(!controls)return;
    controls.autoRotate=!1;
    var R=_fitR,c=_fitCtr,tgt;
    v==="back"?tgt={x:c.x,y:c.y,z:c.z-R}:v==="side"?tgt={x:c.x+R*.95,y:c.y,z:c.z+R*.3}:tgt={x:c.x,y:c.y,z:c.z+R};
    camAnim={from:{x:camera.position.x,y:camera.position.y,z:camera.position.z},to:tgt,t:0,t0:Date.now()};
  }

  function _tickCam(){
    if(camAnim){
      /* time-based easing: completes even when RAF is throttled (hidden or
         occluded tab, low-power mode) instead of counting frames */
      if(!camAnim.t0)camAnim.t0=Date.now();
      camAnim.t=Math.min(1,(Date.now()-camAnim.t0)/450);
      var e=1-Math.pow(1-camAnim.t,3);
      camera.position.x=camAnim.from.x+(camAnim.to.x-camAnim.from.x)*e;
      camera.position.y=camAnim.from.y+(camAnim.to.y-camAnim.from.y)*e;
      camera.position.z=camAnim.from.z+(camAnim.to.z-camAnim.from.z)*e;
      camera.lookAt(_fitCtr.x,_fitCtr.y,_fitCtr.z);
      camAnim.t>=1&&(camAnim=null);
    }
  }

  /* While camAnim runs, controls.update() must NOT run: the straight-line lerp
     passes near the model centre and OrbitControls' minDistance clamp would
     capture the camera mid-flight (the v3 "overzoomed back view" bug). */
  function _animate(){rafId=requestAnimationFrame(_animate),camAnim?_tickCam():controls&&controls.update(),isShowcase&&rimLight&&(rimAngle+=.01,rimLight.position.set(Math.sin(rimAngle)*4,2,Math.cos(rimAngle)*-4)),_lerpColors(),renderer&&scene&&camera&&renderer.render(scene,camera)}

  var _lastW=0,_lastH=0;
  /* Guard: ResizeObserver re-fires after renderer.setSize — refitting on every
     tick resets camAnim.t each frame and the camera never completes a move. */
  function _resize(){
    if(!renderer)return;
    var W=container.clientWidth||400,H=container.clientHeight||480;
    if(W===_lastW&&H===_lastH)return;
    _lastW=W,_lastH=H;
    camera.aspect=W/H,camera.updateProjectionMatrix(),renderer.setSize(W,H),_refit();
  }

  return{
    setColors:function(c){Object.assign(S._target,c),_lerp=!0},
    setText:function(t){Object.assign(S.text,t),_repaint()},
    setPattern:function(p){PATTERNS[p]&&(S.pattern=p,S.premiumImg=null,_repaint())},
    setPremium:function(url){if(!url){S.premiumImg=null,_repaint();return}if(_premiumCache[url]){S.premiumImg=_premiumCache[url],_repaint();return}var img=new Image;img.crossOrigin="anonymous",img.onload=function(){_premiumCache[url]=img,S.premiumImg=img,_repaint()},img.onerror=function(){S.premiumImg=null,_repaint()},img.src=url},
    setLogo:function(dataUrl){if(!dataUrl){S.logoImg=null,_repaint();return}var img=new Image;img.onload=function(){S.logoImg=img,_repaint()},img.onerror=function(){S.logoImg=null,_repaint()},img.src=dataUrl},
    setFabric:function(id){FAB_SPECS[id]&&(S.fabricId=id,model&&_applyFabric())},
    setFont:function(f){S.text.font=f,_repaint()},
    setLogoPos:function(p){S.text.logoPos=p,_repaint()},
    setProduct:function(p){["jersey","shorts","pants"].indexOf(p)>=0&&(S.product=p,model?_applyVisibility():_repaint())},
    setSleeve:function(s){S.text.sleeve=s,model?_applyVisibility():_repaint()},
    setCollar:function(cl){S.text.collar=cl,model?_applyVisibility():_repaint()},
    setView:function(v){_setView(v)},
    snapshot:function(){try{return renderer?renderer.domElement.toDataURL("image/png"):null}catch(e){return null}},
    _debug:function(){return{cam:camera?[camera.position.x,camera.position.y,camera.position.z]:null,dist:camera&&controls?camera.position.distanceTo(controls.target):null,fitR:_fitR,ctr:_fitCtr,minD:controls?controls.minDistance:null,tgt:controls?[controls.target.x,controls.target.y,controls.target.z]:null,anim:!!camAnim}},
    stopAutoRotate:function(){controls&&(controls.autoRotate=!1)},
    startAutoRotate:function(){controls&&isShowcase&&(controls.autoRotate=!0)},
    destroy:function(){cancelAnimationFrame(rafId),window.removeEventListener("resize",_resize),renderer&&(renderer.dispose(),container.contains(renderer.domElement)&&container.removeChild(renderer.domElement))}
  }
}
return{create:create}})();
